import classNames from 'classnames';
import { css } from 'css-literal-loader/styled';
import React from 'react';
import {
  Elements as BaseElements,
  CardCVCElement,
  CardExpiryElement,
  CardNumberElement,
  PaymentRequestButtonElement,
} from 'react-stripe-elements';

import styles from './FormControl.module.scss';

// This will not work in development b/c the asset isn't served over https
import fontsUrl from '../assets/fonts/Biotif-Regular.woff';

const baseStyles = require('./Stripe-baseStyles.module.scss');

function wrapStripeElement(Element) {
  class WrappedStripeElement extends React.Component {
    handleChange = ({ error }) => {
      const { meta, name } = this.props;

      if (meta && (error || meta.invalid)) {
        meta.onError(error ? { [name]: [error] } : {});
      }
    };

    render() {
      const { className, theme = 'primary', placeholder } = this.props;
      return (
        <Element
          onChange={this.handleChange}
          placeholder={placeholder}
          classes={{
            base: classNames(className, styles.formControl, styles[theme]),
            invalid: styles.invalid,
          }}
          style={{
            base: baseStyles,
          }}
        />
      );
    }
  }

  return WrappedStripeElement;
}

export const CardNumber = wrapStripeElement(CardNumberElement);

export const CardCVC = wrapStripeElement(CardCVCElement);

export const CardExpiry = wrapStripeElement(CardExpiryElement);

export { PaymentRequestButtonElement as PaymentRequestButton };

export const Elements = props => (
  <BaseElements
    {...props}
    fonts={[
      {
        src: `url(${fontsUrl})`,
        family: 'Biotif',
        weight: baseStyles.fontWeight,
      },
    ]}
  />
);
